export class Dashboard {
  public PAIDBOOKING!: number;
  public TOPAYCNE!: number;
  public TBBCNR!: number;
  public TBBCNE!: number;
  public TBB3P!: number;
  public TOPAYCNR!: number;
  public FOC!: number;
}
